<template>
    <df-app>
        <template slot="page-head">
            <h2 class="page-head-title">Digital.Framework</h2>
            <h1>360-Grad Analyse von Fachhochschulen entwickelt</h1>
        </template>


        <div class="row">
            <div class="col-md-5">
                <h3>Kriterien - so wird beurteilt:</h3>

                <be-card body-contrast title="7-C Modell">
                    <div class="text-center"><img src="../../assets/images/framework.svg" alt=""></div>
                </be-card>

                <be-card border-color="dark" title="CULTURE">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">
                                Vision
                            </td>
                            <td>
                                Sind Sie und Ihre Mitarbeiter für kommende Entwicklungen gewappnet und verfügen Sie dabei über das notwendige Fachwissen und die richtigen Kompetenzen?<br>
                                Digitalisierung nicht als Gefahr sondern als Chance sehen.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">
                                Umfang
                            </td>
                            <td>
                                #Skills #Tutorial #Outsourcing #Collaboration
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="dark" title="CONNECTIVITY">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Können Ihre Mitarbeiter auf die richtigen Werkzeuge an Hardware und Software zurückgreifen um effizient arbeiten zu können?<br>
                                Komplett vernetzten Touchpoints statt Insellösungen.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #IoT #Cloud #Internet #Server #Mobile #Touchpoints
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="danger" title="CONTENT">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Sind Sie in der Lage Ihren Betrieb medial ins beste Licht zu rücken?<br>
                                Als Evolution von der Textwüste zum LIVE-Stream.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #Video #Foto #Text #Translate #Multimedia #UGC #PIM #DAM
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="primary" title="CHANNEL">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Sind Sie auf möglichst vielen für Sie relevante Plattformen präsent?<br>
                                Als durchgehende Customer-Journey von Social-Media bis zur eigenen Haustür.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #SocialMedia #SearchEngine #ChannelManager #Visibility #CMS
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="success" title="COMMERCE">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Sind Sie in der Lage wiederkehrende Abläufe zu automatisieren?<br>
                                Von der E Mail Anfrage bis zum Self-Checkin.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #Conversion #Revenue #Usability #Payment #ERP
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="warning" title="COMMUNICATION">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Sprechen Sie Ihre Kunden personalisiert an und suchen Sie aktiv den Dialog?<br>
                                Einheitliche Wahrnehmung von der Visitenkarte zur Chatbot.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #Promotion #Dialog #Reputation #Branding #CRM
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

                <be-card border-color="default" title="CONTROLLING">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td style="width:20%">Vision</td>
                            <td>
                                Wissen Sie, welche Massnahmen erfolgreich sind und was Sie in Zukunft besser lassen sollten?<br>
                                Weg von der Strichliste hin zum Echtzeit-Tracking.
                            </td>
                        </tr>
                        <tr>
                            <td style="width:20%">Umfang</td>
                            <td>
                                #KPI #Reporting #Analytics #Monitoring
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </be-card>

            </div>

            <heidiland-framework v-if="isHeidilandSystem"/>
            <digifit-framework v-else/>
        </div>

    </df-app>
</template>

<script>
    import env from '../../mixins/env';

    import DigifitFramework from './framework/Digifit';
    import HeidilandFramework from './framework/Heidiland';

    export default {
        mixins: [env],

        components: { DigifitFramework, HeidilandFramework },
    };
</script>
